var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.5 22 21",
    fill: "#8f9fb4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "-0.001 1 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M21.796 10.475L11.444 1.213a.276.276 0 0 0-.06-.045.611.611 0 0 0-.827-.014L.203 10.416a.611.611 0 1 0 .814.914l1.865-1.67V20.461A1.54 1.54 0 0 0 4.42 22h3.267c.797 0 1.444-.647 1.444-1.444v-5.491c0-.122.1-.222.221-.222h3.3c.121 0 .22.1.22.222v5.49c0 .798.648 1.445 1.445 1.445h3.267c.86 0 1.539-.847 1.539-1.928v-5.034-1.54V9.72l1.863 1.67a.614.614 0 0 0 .865-.05.623.623 0 0 0-.055-.864zm-3.9 3.02V20.062c0 .439-.217.706-.317.706h-3.267a.223.223 0 0 1-.222-.222v-5.482c0-.797-.647-1.444-1.443-1.444H9.348c-.796 0-1.443.647-1.443 1.444v5.49c0 .123-.1.223-.222.223H4.416a.317.317 0 0 1-.316-.317v-5.645-4.834-1.417l6.868-6.139 6.928 6.197v4.871z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1fa762247c34e361097de274ea80ca4e.svg";
export { ForwardRef as ReactComponent };